import React, { useState } from 'react';
import Marquee from 'react-fast-marquee';

const PartnersSection = () => {
  const [failedImages, setFailedImages] = useState(new Set());
  // Equipamentos Profissionais - APENAS OS QUE FUNCIONAM
  const partnersRow1 = [
    { name: 'Sony', text: 'SONY' },
    { name: 'DJI', text: 'DJI' },
    { name: 'Godox', text: 'GODOX' },
    { name: 'Tamron', text: 'TAMRON' },
    { name: 'Hohem', text: 'HOHEM' },
    { name: 'K&F Concept', text: 'K&F CONCEPT' }
  ];

  const partnersRow2 = [
    { name: 'Viltrox', text: 'VILTROX' },
    { name: 'Tilta', text: 'TILTA' },
    { name: 'Hollyland', text: 'HOLLYLAND' },
    { name: 'HyperX', text: 'HYPERX' },
    { name: 'Razer', text: 'RAZER' },
    { name: 'Samyang', text: 'SAMYANG' }
  ];

  // Plataformas & Ferramentas Digitais
  const platformsRow = [
    { name: 'Meta Business', text: 'META BUSINESS' },
    { name: 'Google Partners', text: 'GOOGLE PARTNERS' },
    { name: 'WordPress', text: 'WORDPRESS' },
    { name: 'Wix', text: 'WIX' },
    { name: 'Adobe', text: 'ADOBE' },
    { name: 'Instagram', text: 'INSTAGRAM' }
  ];

  return (
    <section className="py-16 bg-[#0A0A0A] relative overflow-hidden border-t border-white/5">
      <div className="container mx-auto px-6 mb-12">
        <div className="text-center">
          <div className="inline-flex items-center space-x-2 mb-4">
            <div className="w-8 h-[1px] bg-[#4ECDC4]"></div>
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#4ECDC4]">
              Equipamentos Profissionais
            </span>
            <div className="w-8 h-[1px] bg-[#4ECDC4]"></div>
          </div>
          <h2 className="text-2xl md:text-4xl tracking-tight font-bold text-[#F5F5F0] mb-3">
            Arsenal <span className="text-[#4ECDC4]">Técnico</span>
          </h2>
          <p className="text-base text-[#A1A1AA] max-w-2xl mx-auto font-light">
            Investimos em equipamentos de ponta para entregar qualidade cinematográfica profissional
          </p>
        </div>
      </div>

      {/* Equipamentos - Linha 1 */}
      <div className="mb-6">
        <Marquee gradient={false} speed={40} className="overflow-hidden">
          {partnersRow1.map((partner, index) => (
            <div
              key={`row1-${index}`}
              className="mx-8 flex items-center h-16 transition-all duration-300 opacity-70 hover:opacity-100"
            >
              <span className="text-white font-black text-lg tracking-wider hover:text-[#4ECDC4] transition-all duration-300 whitespace-nowrap">
                {partner.text}
              </span>
            </div>
          ))}
        </Marquee>
      </div>

      {/* Equipamentos - Linha 2 */}
      <div className="mb-12">
        <Marquee gradient={false} speed={40} direction="right" className="overflow-hidden">
          {partnersRow2.map((partner, index) => (
            <div
              key={`row2-${index}`}
              className="mx-8 flex items-center h-16 transition-all duration-300 opacity-70 hover:opacity-100"
            >
              <span className="text-white font-black text-lg tracking-wider hover:text-[#4ECDC4] transition-all duration-300 whitespace-nowrap">
                {partner.text}
              </span>
            </div>
          ))}
        </Marquee>
      </div>

      {/* Plataformas Digitais */}
      <div className="border-t border-white/10 pt-8">
        <h3 className="text-center text-[#4ECDC4] text-sm font-bold uppercase tracking-wider mb-6">
          Plataformas & Ferramentas Digitais
        </h3>
        <Marquee gradient={false} speed={35} className="overflow-hidden">
          {platformsRow.map((platform, index) => (
            <div
              key={`platform-${index}`}
              className="mx-8 flex items-center h-14 transition-all duration-300 opacity-60 hover:opacity-100"
            >
              <span className="text-white/80 font-bold text-base tracking-wide hover:text-[#4ECDC4] transition-all duration-300 whitespace-nowrap">
                {platform.text}
              </span>
            </div>
          ))}
        </Marquee>
      </div>

      {/* Bottom Text Banner - Infinite Scroll */}
      <div className="mt-16 border-t border-white/5 pt-8">
        <Marquee gradient={false} speed={50} className="text-[#4ECDC4] font-black text-2xl tracking-wider">
          <span className="mx-8">PRODUÇÃO AUDIOVISUAL 4K</span>
          <span className="mx-8">•</span>
          <span className="mx-8">DRONES FPV INDOOR</span>
          <span className="mx-8">•</span>
          <span className="mx-8">WEBSITES DE CONVERSÃO</span>
          <span className="mx-8">•</span>
          <span className="mx-8">GESTÃO DE REDES SOCIAIS</span>
          <span className="mx-8">•</span>
          <span className="mx-8">IDENTIDADE VISUAL ESTRATÉGICA</span>
          <span className="mx-8">•</span>
        </Marquee>
      </div>
    </section>
  );
};

export default PartnersSection;
